import { gql } from "@apollo/client";
import { Terminal as TerminalEntity } from "@towersystems/roam-common/lib/generated-types";
import { client } from "../../../apollo";
import TerminalModel from "../../data/model/Terminal";
import { listOptions, listVariables } from "../constants";
import { EntityResourceDefinition } from "../entity-resource-definition";
import {
  PaginatedListMetaNoNestingFragment,
  TerminalNoNestingFragment,
} from "@towersystems/roam-common/lib/generated-graphql-fragment";
import { pageQuery } from "../page-query";

const terminalsQuery = gql`
  ${TerminalNoNestingFragment}
  ${PaginatedListMetaNoNestingFragment}
query GetTerminals(${listVariables}) {
    terminals(${listOptions}) {
        items {
           ...TerminalNoNesting
        }
        meta {
          ...PaginatedListMetaNoNesting
        }
    }
}
`;

export const terminalDefinition = new EntityResourceDefinition<
  TerminalEntity,
  TerminalModel
>({
  entity: "terminals",
  query: terminalsQuery,
  prepareEntity: (newEntity, fetchedEntity) => {
    newEntity.name = fetchedEntity.name || "";
    newEntity.invoiceSequence = fetchedEntity.invoiceSequence;
    newEntity.invoiceSequence = fetchedEntity.invoiceSequence;
    newEntity.saleSufix = fetchedEntity.saleSufix;
    newEntity.salePrefix = fetchedEntity.salePrefix;
    newEntity.enabled = fetchedEntity.enabled;
    newEntity.paymentMethodIds = fetchedEntity.paymentMethodIds;
    newEntity.printReceiptOnCheckout = fetchedEntity.printReceiptOnCheckout;
    newEntity.openTerminalClosureId =
      fetchedEntity.openTerminalClosureId || null;
    newEntity.terminalOpenTime = fetchedEntity.terminalOpenTime || null;
    newEntity.terminalCloseTime = fetchedEntity.terminalCloseTime || null;

    if (fetchedEntity.defaultReceiptTemplateId) {
      newEntity.defaultReceiptTemplate.id =
        fetchedEntity.defaultReceiptTemplateId;
    }
  },
  fetchEntities: (options) => {
    return pageQuery(client, "terminals", terminalsQuery, options);
  },
});
